module.exports = __webpack_public_path__ + "img/money.c329a358.png";